import { jsxs as _jsxs } from "react/jsx-runtime";
export default function UIValidation(props) {
    return (_jsxs("div", { style: { maxWidth: '100%' }, children: [props.children, props.error && _jsxs("span", { style: { color: '#c00000', fontWeight: 'bold', textAlign: 'right', marginTop: '2px' }, children: [" ", props.error] })] }));
}
//# sourceMappingURL=uiValidation.js.map